import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function initEnterRowAnimation() {
    const rows = document.querySelectorAll('.enter-row,.services-hover-list > div');

    if (!rows.length) {
        return;
    }

    ScrollTrigger.refresh();

    ScrollTrigger.batch(rows, {
        start: "top 90%", once: true, interval: 0.2, onEnter: (batch) => {
            gsap.fromTo(batch, {x: -80, opacity: 0}, {
                x: 0, opacity: 1, duration: 1, ease: "power2.out", stagger: 0.38
            });
        }
    });
}

// ─────────────────────────────────────────────────────────────────────────────
// SERVICE DIGITAL ROWS + FAQ ACCORDION  →  pagina /servizi/digital
// Col-titolo entra da sinistra, col-subtitle e col-desc salgono dal basso.
// Accordion: ogni item entra in stagger dal basso.
// ─────────────────────────────────────────────────────────────────────────────
function initServiceDigitalAnimation() {

    // ── 3 righe di testo ─────────────────────────────────────────────────────
    const rows = document.querySelectorAll('.svc-digital-row');

    rows.forEach((row) => {
        const titleCol  = row.querySelector('.svc-digital-col--title');
        const otherCols = row.querySelectorAll('.svc-digital-col:not(.svc-digital-col--title)');

        if (titleCol) {
            gsap.set(titleCol,   { x: -60, opacity: 0 });
        }

        if (otherCols.length) {
            gsap.set(otherCols,  { y: 50,  opacity: 0 });
        }

        ScrollTrigger.create({
            trigger: row,
            start: 'top 72%',
            once: true,
            onEnter: () => {
                if (titleCol) {
                    gsap.to(titleCol, { x: 0, opacity: 1, duration: 0.9, ease: 'power3.out' });
                }
                if (otherCols.length) {
                    gsap.to(otherCols, {
                        y: 0, opacity: 1,
                        duration: 0.9, ease: 'power3.out',
                        stagger: 0.30, delay: 0.15,
                    });
                }
            }
        });
    });

    // ── FAQ accordion ─────────────────────────────────────────────────────────
    const accordion = document.querySelector('.geo-faq__accordion');
    if (!accordion) {
        return;
    }

    const faqItems = accordion.querySelectorAll('.accordion-item');
    if (!faqItems.length) {
        return;
    }

    gsap.set(faqItems, { y: 45, opacity: 0 });

    ScrollTrigger.create({
        trigger: accordion,
        start: 'top 82%',
        once: true,
        onEnter: () => {
            gsap.to(faqItems, {
                y: 0,
                opacity: 1,
                duration: 0.65,
                ease: 'power3.out',
                stagger: 0.15,
            });
        }
    });
}

export {initEnterRowAnimation, initServiceDigitalAnimation};
